// Brunchi wordmark — actual brand logo with transparent background
export default function BrunchiWordmark({ size = 68, showTagline = false }) {
  return (
    <div className="inline-flex items-center leading-none" data-testid="brunchi-wordmark">
      <img
        src="/brunchi-wordmark.png"
        alt="Brunchi"
        style={{ height: size, width: "auto" }}
        className="block"
      />
      {showTagline && (
        <div className="ml-3 hidden sm:flex items-center gap-1.5 text-[10px] uppercase tracking-[0.28em] font-medium text-[color:var(--brunchi-ink-soft)]">
          <span>FRESH</span>
          <span className="inline-block w-1.5 h-1.5 rounded-full border border-[color:var(--brunchi-green)]" />
          <span>NATURAL</span>
          <span className="inline-block w-1.5 h-1.5 rounded-full border border-[color:var(--brunchi-green)]" />
          <span>SMART</span>
        </div>
      )}
    </div>
  );
}
